import { render } from "./UserList.vue?vue&type=template&id=05af13f8&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"

import "./UserList.vue?vue&type=style&index=0&id=05af13f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05af13f8"

export default script